require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./works-2018-05-15-maze.json") })
        }
      }, "path---works-2018-05-15-maze");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---works-2018-05-15-maze!./.cache/json/works-2018-05-15-maze.json
// module id = 412
// module chunks = 231608221292675